import type { AppModule } from "../types";
import { s } from "./strings";
import { timesheetOn } from "./visibility";

export const timesheetModule: AppModule = {
  name: "timesheet",
  routes: {
    shell: [
      {
        path: "/timesheet",
        handle: { title: s.title },
        lazy: () => import("./pages/TimesheetPage").then((m) => ({ Component: m.TimesheetRoute })),
      },
    ],
  },
  sidebar: [
    {
      id: "TIMESHEET",
      label: "Timesheet",
      path: "/timesheet",
      icon: "timesheet",
      alt: "View Timesheet",
      visible: timesheetOn,
    },
  ],
};
